export enum DatoExportType {
    followUp = 'followUp',
    screening = 'screening',
}
